module.exports = __webpack_public_path__ + "static/media/20ECE17.a20c0dfa.jpg";